import liveswitch from "fm.liveswitch";
import { useState } from "react";

type Props = {
    label: string;
    inputs: liveswitch.SourceInput[];
    onChange: (input: liveswitch.SourceInput) => Promise<void>;
    defaultValue: string;
};

export default function SourceInputDropdown(props: Props) {
    const [loading, setLoading] = useState<boolean>(false);
    const [selected, setSelected] = useState<string>(props.defaultValue);

    async function changeSourceInput(sourceId: string) {
        try {
            setSelected(sourceId);
            setLoading(true);
            await props.onChange(props.inputs.find((x) => x.getId() === sourceId)!);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="sdd-wrap">
            <label className="sdd-label">{props.label}</label>
            <div className="sdd-select-wrap">
                <select
                    className="sdd-select"
                    disabled={loading}
                    value={selected}
                    onChange={e => changeSourceInput(e.target.value)}
                >
                    {props.inputs.map(input => (
                        <option key={input.getId()} value={input.getId()}>
                            {input.getName()}
                        </option>
                    ))}
                </select>
                {loading && <span className="sdd-loading" />}
            </div>

            <style>{`
                .sdd-wrap {
                    width: 100%;
                }

                .sdd-label {
                    display: block;
                    font-size: 0.72rem;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.08em;
                    color: var(--hx-muted, #64748b);
                    margin-bottom: 0.4rem;
                }

                .sdd-select-wrap {
                    position: relative;
                }

                .sdd-select {
                    width: 100%;
                    background: var(--hx-card, #fff);
                    border: 1.5px solid var(--hx-line, #e2e8f0);
                    border-radius: var(--hx-radius-sm, 10px);
                    padding: 0.6rem 2rem 0.6rem 0.75rem;
                    color: var(--hx-ink, #0f172a);
                    font-size: 0.875rem;
                    outline: none;
                    cursor: pointer;
                    transition: border-color 0.15s, background 0.15s;
                    font-family: inherit;
                    -webkit-appearance: none;
                    appearance: none;
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
                    background-repeat: no-repeat;
                    background-position: right 0.75rem center;
                }

                .sdd-select:hover {
                    border-color: #cbd5e1;
                }

                .sdd-select:focus {
                    border-color: var(--hx-blue, #2563eb);
                    background-color: var(--hx-blue-soft, #eff6ff);
                }

                .sdd-select:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }

                .sdd-select option {
                    background: #fff;
                    color: var(--hx-ink, #0f172a);
                }

                .sdd-loading {
                    position: absolute;
                    right: 0.5rem;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 14px;
                    height: 14px;
                    border: 2px solid var(--hx-line, #e2e8f0);
                    border-top-color: var(--hx-blue, #2563eb);
                    border-radius: 50%;
                    animation: sddSpin 0.6s linear infinite;
                }

                @keyframes sddSpin {
                    to { transform: translateY(-50%) rotate(360deg); }
                }
            `}</style>
        </div>
    );
}
